import Vue from 'vue';
import VueRouter from 'vue-router';

import map from './maplibre-main.vue';
import selectedLocation from './selectedLocation.vue';
import mapDefault from './mapDefault.vue'; // <-- your "no selection" component


Vue.use(VueRouter);

export default [
    {
        path: '/:locale?/map', // locale is optional
        component: map,
        children: [
            {
                path: '',
                name: 'locations.map.index',
                component: mapDefault,
                meta: { title: 'Map' }
            },
            {
                path: ':slug',
                name: 'locations.map.show',
                component: selectedLocation,
                meta: { title: 'Show' },
                props: route => ({ mode: 'show', slug: route.params.slug }),
            },
        ],
    },
];
